import React, { useEffect, useState } from "react";
import Sidebar from "../Sidebar/Sidebar";
import Navbar from "../Navbar/Navbar";
import { useLocation } from 'react-router-dom';
import { sidebarData } from "../../Constants";
import { Helmet } from "react-helmet";
import logo from '../../Assets/Images/logo.png';
import Footer from "../Footer/Footer";
function Layout({ children }) {
    const location = useLocation();
    const currentPath = location.pathname.split("/")[1];
    const landingPages = ["login","striperesponse","invoice","stripe","payment","estimate","whatsnew","privacypolicy","terms","stripeconnect"];
    const [isSidebarVisible, setSidebarVisible] = useState(false);
    const AppName = process.env.REACT_APP_NAME;
    const currentNavItem = sidebarData.find((item) => item.link === currentPath);
    // Display the title from the matched item or a default value if not found
    const title = currentNavItem ? currentNavItem.title : "";
    const handleClickOutside = (event) => {
        if ((!event.target.closest(".sidebar-wrapper")) && (window.innerWidth<768)) {
          // alert("click");
          setSidebarVisible(false);
        }
      };
    
      useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
      }, []);
    return (
        <>
         <Helmet>
          <title>{title && `${title} |`} {AppName}</title>
        </Helmet>
            {landingPages.includes(currentPath) ?
                children
                : (
                    <div className="wrapper">
                        <Sidebar />


                        {/* Main Content */}
                        <Navbar />
                        <div id="content-wrapper" className="d-flex flex-column content-wrapper">
                            <div id="content" className="content">
                            
                                <div className="container-fluid">
                                    <div className="page">
                                        {children}
                                    </div>
                                    <Footer/>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
        </>
    )
}

export default Layout